import request from '@/utils/request';

/* eslint-disable */
const actions = {
  async addCollection({ dispatch, commit }, collection) {
    try {
      const { data } = await request.post('/collections', collection);

      if (data.error) {
        throw Error('Server-side validation failed');
      }
    } catch (err) {
      throw err;
    }
  },
};

export default actions;
